((d, w) => {
  const quicklinks = new Swiper(".block-quicklinks", {
    slidesPerView: "auto",
    loop: false,
  });
  const team = new Swiper(".team-carousel", {
    slidesPerView: "auto",
    loop: false,
    spaceBetween: 2,
  });
})(document, window);
